// extracted by mini-css-extract-plugin
module.exports = {"container":"FailedModal_container__3ZEq_","icon":"FailedModal_icon__em0hG","body":"FailedModal_body__1IqCk","title":"FailedModal_title__2MkGZ","text":"FailedModal_text__3iN28"};